/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// import { OrderContact } from './order.contact';

export class Order {
  ID: string;
  ORDER_BV: boolean;
  ORDER_EA: boolean;

  BV_TYPE: ValuationType;
  EA_TYPE: AppraisalType;

  COMPANY_NAME: string[];
  COMPANY_DBA: string;

  EA_LOCATIONS: string;
  EA_ENG_ADDRESS: string;
  RUSH: boolean;
  RUSH_SPEED: number;
  PURPOSE_FINANCING: boolean;
  PURPOSE_DESC: string;
  MULTI_LOCATION: boolean;
  MULTI_LOCATION_DESC: string;

  // Contacts
  PERSON_SUBMIT: Contact;
  PERSON_COMPANY: Contact;
  PERSON_LENDER: Contact;
  PERSON_SELLER: Contact;

  SELLER_PERMISSION: boolean;
  SELLER_CAN_CONTACT: boolean;
  SELLER_NOT_AVAILABLE: boolean;

  COMMENTS: string;
  EQ_LIST: boolean;
  DATE_SUBMITTED: Date;

  SUGGESTIONS: string;

  constructor(value: any = {}) {
    this.PERSON_SUBMIT = new Contact();
    this.PERSON_COMPANY = new Contact();
    this.PERSON_LENDER = new Contact();
    this.PERSON_SELLER = new Contact();

    Object.assign(this, value);
  }

  static parse(json: any): Order {
    if (json) {
      const a = new Order();

      a.ID = json.ID;
      a.ORDER_BV = json.ORDER_BV;
      a.ORDER_EA = json.ORDER_EA;
      a.BV_TYPE = json.BV_TYPE;
      a.EA_TYPE = json.EA_TYPE;
      a.COMPANY_NAME = json.COMPANY_NAME;
      a.COMPANY_DBA = json.COMPANY_DBA;
      a.EA_LOCATIONS = json.EA_LOCATIONS;
      a.EA_ENG_ADDRESS = json.EA_ENG_ADDRESS;
      a.RUSH = json.RUSH;
      a.RUSH_SPEED = json.RUSH_SPEED;
      a.PURPOSE_FINANCING = json.PURPOSE_FINANCING;
      a.PURPOSE_DESC = json.PURPOSE_DESC;
      a.MULTI_LOCATION = json.name;

      if(json.PERSON_SUBMIT)
        a.PERSON_SUBMIT = Contact.parse(json.PERSON_SUBMIT);

      if(json.PERSON_COMPANY)
        a.PERSON_COMPANY = Contact.parse(json.PERSON_COMPANY);

      if(json.PERSON_LENDER)
        a.PERSON_LENDER = Contact.parse(json.PERSON_LENDER);

      if(json.PERSON_SELLER)
        a.PERSON_SELLER = Contact.parse(json.PERSON_SELLER);

      a.MULTI_LOCATION_DESC = json.MULTI_LOCATION_DESC;
      a.SELLER_CAN_CONTACT = json.SELLER_CAN_CONTACT;
      a.SELLER_NOT_AVAILABLE = json.SELLER_NOT_AVAILABLE;
      a.SELLER_PERMISSION = json.SELLER_PERMISSION;
      a.COMMENTS = json.COMMENTS;
      a.EQ_LIST = json.EQ_LIST;

      return a;
    } else { return null; }
  }

  static parseArray(json: any[]): Order[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new Order(j));
        }
      }
    }
    return arr;
  }
}

export class Contact {
  FIRST_NAME: string;
  LAST_NAME: string;
  CONTACT: string;
  EMAIL: string;
  PHONE: string;
  PHONE_TYPE: PhoneType;
  PHONE_EXT: string;
  OTHER: string;

  constructor(value: Object = {}) {
    this.FIRST_NAME = '';
    this.LAST_NAME = '';
    this.CONTACT = '';
    this.EMAIL = '';
    this.PHONE = '';
    this.PHONE_EXT = '';
    this.OTHER = '';

    Object.assign(this, value);
  }

  static parse(json: any): Contact {
    if (json) {
      const a = new Contact();

      a.FIRST_NAME = json.FIRST_NAME;
      a.LAST_NAME = json.LAST_NAME;
      a.CONTACT = json.CONTACT;
      a.EMAIL = json.EMAIL;
      a.PHONE = json.PHONE;
      a.PHONE_TYPE = json.PHONE_TYPE;
      a.PHONE_EXT = json.PHONE_EXT;
      a.OTHER = json.OTHER;

      return a;
    } else { return null; }
  }

  /**
   * FIXME: Reset
   * */
  reset(): void {
    this.CONTACT = '';
    this.EMAIL = '';
    this.FIRST_NAME = '';
    this.LAST_NAME = '';
    this.OTHER = '';
    this.PHONE = '';
  }
}

export enum ValuationType {
  CONCLUSION = 'CONCLUSION',
  CALCULATION = 'CALCULATION',
  IV = 'IV',
  OTHER = ''
}

export enum AppraisalType {
  DESKTOP = 'DESKTOP',
  SUMMARY = 'SUMMARY',
  BOTH = 'BOTH'
}

export enum PhoneType {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS'
}

export class OrderQueryParam {
  QUERY: string;
  ORDER: string;
  FIELD: string;
  PAGE: number;

  constructor() {
    this.QUERY = '';
    this.ORDER = '';
    this.FIELD = '';
    this.PAGE = 1;
  }
}
